import axios from "../axios";

export async function fetchWebpage(slug) {
  return axios.get(`/webpage/pages/` + slug);
}

export async function fetchWebPages(controller) {
  return axios.get(`/webpage/pages/`, { params: controller });
}

export async function createWebPage(payload) {
  return axios.post(`/webpage/pages`, { web_page: payload });
}

export async function updateWebPage(payload) {
  const { id, content, create_new_version, ...rest } = payload;
  const webPageParams = {};
  
  // Only include web_page params if they exist
  if (Object.keys(rest).length > 0) {
    webPageParams.web_page = rest;
  }
  
  // Include content if provided
  if (content !== undefined) {
    webPageParams.content = content;
  }
  
  // Include create_new_version flag if provided
  if (create_new_version !== undefined) {
    webPageParams.create_new_version = create_new_version;
  }
  
  return axios.put(`/webpage/pages/${id}`, webPageParams);
}

export async function fetchPageVersions(pageId) {
  return axios.get(`/webpage/pages/${pageId}/versions`);
}

export async function restorePageVersion(pageId, versionId) {
  return axios.post(`/webpage/pages/${pageId}/restore`, { version_id: versionId });
}
